export default function StatsSection() {
  const { t } = useTranslation();
  const stats = [
    { num: t('home.stat1_num'), label: t('home.stat1_label') },
    { num: t('home.stat2_num'), label: t('home.stat2_label') },
    { num: t('home.stat3_num'), label: t('home.stat3_label') },
    { num: t('home.stat4_num'), label: t('home.stat4_label') },
  ];
  return (
    <section
      className="relative py-24 overflow-hidden"
      style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1544197150-b99a580bb7a8?auto=format&fit=crop&w=1920&q=80)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-primary-950/88" />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-900/60 via-transparent to-slate-900/60" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row gap-16 items-center">
          <div className="lg:w-1/3">
            <span className="inline-block bg-white/10 text-primary-300 text-xs font-semibold px-3 py-1 rounded-full tracking-wide uppercase mb-4 border border-white/10">
              {t('home.stats_badge')}
            </span>
            <h2 className="font-display text-3xl sm:text-4xl font-bold text-white mb-4">{t('home.stats_title')}</h2>
            <p className="text-slate-400 leading-relaxed">{t('home.stats_desc')}</p>
          </div>
          <div className="lg:w-2/3 grid grid-cols-2 gap-8">
            {stats.map((s, i) => (
              <div key={i} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/8 transition-colors">
                <div className="font-display text-4xl sm:text-5xl font-black text-white mb-1 tabular-nums">{s.num}</div>
                <div className="text-slate-400 text-sm font-medium uppercase tracking-wide">{s.label}</div>
                <div className="mt-4 h-0.5 bg-gradient-to-r from-primary-500/50 to-transparent rounded-full" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
